import * as controlCenterActions from '../actions/control-center';
import { IStation } from '../models/station';

export interface IControlCenterState {
  loading: boolean;
  phones: IStation[];
  modifyingPhoneIds: number[];
  error?: any;
}
const initialState: IControlCenterState = {
  loading: false,
  phones: [],
  modifyingPhoneIds: [],
  error: null
};

export default function (
  state: IControlCenterState = initialState,
  action
): IControlCenterState {
  switch (action.type) {
    case controlCenterActions.LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };

    case controlCenterActions.LOADED:
      return {
        ...state,
        loading: false,
        phones: action.phones,
        error: null
      };

    case controlCenterActions.LOAD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case controlCenterActions.ENABLING:
      return {
        ...state,
        modifyingPhoneIds: [action.id],
        error: null
      };

    case controlCenterActions.ENABLED:
      return {
        ...state,
        modifyingPhoneIds: [],
        error: null
      };

    case controlCenterActions.ENABLE_FAILED:
      return {
        ...state,
        error: action.error,
        modifyingPhoneIds: []
      };

    case controlCenterActions.DISABLING:
      return {
        ...state,
        modifyingPhoneIds: [action.id],
        error: null
      };

    case controlCenterActions.DISABLED:
      return {
        ...state,
        modifyingPhoneIds: [],
        error: null
      };

    case controlCenterActions.DISABLE_FAILED:
      return {
        ...state,
        error: action.error,
        modifyingPhoneIds: []
      };

    case controlCenterActions.ENABLING_MULTIPLE:
      return {
        ...state,
        modifyingPhoneIds: action.ids,
        error: null
      };

    case controlCenterActions.ENABLED_MULTIPLE:
      return {
        ...state,
        modifyingPhoneIds: [],
        error: null
      };

    case controlCenterActions.ENABLE_MULTIPLE_FAILED:
      return {
        ...state,
        error: action.error,
        modifyingPhoneIds: []
      };

    case controlCenterActions.DISABLING_MULTIPLE:
      return {
        ...state,
        modifyingPhoneIds: action.ids,
        error: null
      };

    case controlCenterActions.DISABLED_MULTIPLE:
      return {
        ...state,
        modifyingPhoneIds: [],
        error: null
      };

    case controlCenterActions.DISABLE_MULTIPLE_FAILED:
      return {
        ...state,
        error: action.error,
        modifyingPhoneIds: []
      };
  }

  return state;
}
